
<form [formGroup]="jobOfferForm">
    <div class="main-create-job-offer">
        <div id="content" class="main-content" role="main">
            <div class="step-indicator hideInMobile" *ngIf="status === 0">
                <div class="step initial-step" [class.active]="step >= 1" (click)="goToStep(1)">{{ 'createJobOffer.step2.steps.step1' | translate }}</div>
                <div class="step" [class.active]="step >= 2">{{ 'createJobOffer.step2.steps.step2' | translate }}</div>
                <div class="step final-step" [class.active]="step >= 3">{{ 'createJobOffer.step2.steps.step3' | translate }}</div>
            </div>

            <div class="step-indicator hideInMobile" *ngIf="status === 1">
                <div class="step initial-step" [class.active]="true" (click)="goToStep(1)">{{ 'createJobOffer.step2.steps.step1' | translate }}</div>
                <div class="step" [class.active]="true" (click)="goToStep(2)">{{ 'createJobOffer.step2.steps.step2' | translate }}</div>
                <div class="step final-step" [class.active]="true" (click)="goToStep(3)">{{ 'createJobOffer.step2.steps.step3' | translate }}</div>
            </div>
    
            <div class="step-indicator hideInDesktop" *ngIf="status === 0">
                <div class="step initial-step" [class.active]="step >= 1" (click)="goToStep(1)">{{ 'createJobOffer.step2.steps.step' | translate }} 1</div>
                <div class="step" [class.active]="step >= 2">{{ 'createJobOffer.step2.steps.step' | translate }} 2</div>
                <div class="step final-step" [class.active]="step >= 3">{{ 'createJobOffer.step2.steps.step' | translate }} 3</div>
            </div>

            <div class="step-indicator hideInDesktop" *ngIf="status === 1">
                <div class="step initial-step" [class.active]="true" (click)="goToStep(1)">{{ 'createJobOffer.step2.steps.step' | translate }} 1</div>
                <div class="step" [class.active]="true" (click)="goToStep(2)">{{ 'createJobOffer.step2.steps.step' | translate }} 2</div>
                <div class="step final-step" [class.active]="true" (click)="goToStep(3)">{{ 'createJobOffer.step2.steps.step' | translate }} 3</div>
            </div>

            <h2>{{ 'createJobOffer.step2.title' | translate }}</h2>
                <section>
                    <h4>{{ 'createJobOffer.step2.question' | translate }}</h4>
                    <div class="message-saved" *ngIf="message_saved">
                        <p>{{message_saved}}</p>
                    </div>
                    <!--<p>Selecciona un <b>máximo de 3 habilidades</b>. Cuanta más precisión, más fácil será encontrar el perfil que realmente quieres. <b>Si solo uno es importante, alcanzará con marcar solo esa.</b> </p>
                -->
                    <div class="row" style="padding-top: 20px; padding-bottom: 20px;">
                            <button  *ngFor="let category of selectedCualitiesNameOrdered"
                            style="padding: 12px; margin: 6px;"
                            type="button"
                            (click)="addcategory(category)"
                            [ngClass]="{'selected_chip': jobOfferForm.get('selectedCualities')?.value.includes(category), 'unselected_chip': !jobOfferForm.get('selectedCualities')?.value.includes(category)}"
                            >{{ selectedCualities[category] }}</button>
                    </div>

                    <div *ngIf="jobOfferForm.get('selectedCualities')?.value.includes('technicalSkills')" style="margin-top:20px;">
                        <h4>{{ 'createJobOffer.step2.technical.title' | translate }}</h4>
                        <p [innerHTML]="'createJobOffer.step2.technical.description' | translate"></p>

                        <mat-form-field appearance="fill" class="width-variable">
                            <mat-label>{{ 'createJobOffer.step2.technical.placeholder' | translate }}</mat-label>
                            <input matInput formControlName="technicalhabilities">
                        </mat-form-field>
                    </div>
                </section>

                <section class="section-margin-variable" *ngFor="let quality of jobOfferForm.get('selectedCualities')?.value">
                    <div *ngIf="quality != 'technicalSkills'">
                        <h4>{{selectedCualities[quality]}}</h4>
                        <p [innerHTML]="('createJobOffer.step2.ratings.instruction' | translate: { quality: selectedCualities[quality] })"></p>
                        <div class="skills-container" *ngFor="let skill of selectedCualities_all[quality]; let i = index">
                            <div>   
                                <label class="skill-label"
                                [ngClass]="{'formError': jobOfferForm.get('groupedCualities')?.get(quality)?.get(transform_name(skill.name))?.value === '' && jobOfferForm.get('groupedCualities')?.get(quality)?.get(transform_name(skill.name))?.touched }"
                                >{{i + 1}}. {{skill.name}}</label>
                            </div>
                            <div>
                                <mat-radio-group class="rating-group">
                                    <button *ngFor="let option of ['1', '2', '3', '4', '5']"
                                    type="button"
                                    [ngClass]="{'selected': isselected(quality, skill.name, option)}"
                                    (click)="setOption(quality, skill.name, option)"
                                    [value]="option" class="rating-button">
                                    {{ option }}
                                    </button>
                                </mat-radio-group>
                            </div>
                            <div></div>
                        </div>
                    </div>
                    
                </section>

                <div class="actions two-actions" style="margin-top: 10%; padding-bottom: 5%;">
                    <div class = "actions-left">
                        <button mat-raised-button color="primary" type="button"  class = "light-button" (click)="goBack()">
                            <span  *ngIf="!loading">{{ 'createJobOffer.step2.actions.back' | translate }}</span>
                            <div style = "height:30px;" *ngIf="loading"><img class = "loading-button" src="/assets/spinner.gif" [alt]="'createJobOffer.step2.actions.loading' | translate"></div>
                         </button>
                    </div>
                    <div class = "actions-right">
                        <button mat-raised-button color="primary" type="button"  class = "light-button" style="margin-right: 15px;" (click)="save_progress()">
                            <span  *ngIf="!loading">{{ 'createJobOffer.step2.actions.save' | translate }}</span>
                            <div style = "height:30px;" *ngIf="loading"><img class = "loading-button" src="/assets/spinner.gif" [alt]="'createJobOffer.step2.actions.loading' | translate"></div>
                         </button>
                        <button mat-raised-button color="primary" type="button" class = "linkedin-button" (click)="nextStep()">
                            <span  *ngIf="!loading">{{ 'createJobOffer.step2.actions.continue' | translate }}</span>
                            <div style = "height:30px;" *ngIf="loading"><img class = "loading-button" src="/assets/spinner.gif" [alt]="'createJobOffer.step2.actions.loading' | translate"></div>
                        </button>
        
                    </div>
                    
                </div>
        </div>
    </div>
</form>